import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface OptionsDataType<T> {
	data: T[];
	isEmty: boolean;
	isLoading: boolean;
	shouldFetch?: boolean;
	fetchInterval?: number;
	lastRefetchDate?: number;
}

export interface OptionsState {
	optionsData: {
		[key: string]: OptionsDataType<any>;
	};
}

const initialState: OptionsState = {
	optionsData: {},
};

type OptionType = {
	value: string;
	label: string;
	[key: string]: any;
};

type SetOptionsDataPayloadType = {
	optionsName: string;
	data: OptionType[];
	shouldFetch?: boolean;
	fetchInterval?: number;
	lastRefteDate?: number;
};

const optionsSlice = createSlice({
	name: 'options',
	initialState,
	reducers: {
		createOptionsReducer: (state, action: PayloadAction<string>) => {
			state.optionsData = {
				...state.optionsData,
				[action.payload]: {
					data: [],
					isEmty: true,
					isLoading: true,
					shouldFetch: false,
					fetchInterval: 0,
				},
			};
		},

		setOptionsData: (state, action: PayloadAction<SetOptionsDataPayloadType>) => {
			state.optionsData = {
				...state.optionsData,
				[action.payload.optionsName]: {
					data: action.payload.data,
					isEmty: false,
					isLoading: false,
					shouldFetch: action.payload.shouldFetch ?? false,
					fetchInterval: action.payload.fetchInterval ?? 0,
				},
			};
		},
	},
});

export const { createOptionsReducer, setOptionsData } = optionsSlice.actions;

export default optionsSlice.reducer;
// const createOptionsReducer = (state, action) => {};
